<form [formGroup]="form" class="date-form" (ngSubmit)="updateSearch()">
  <label class="label">{{ label || 'ADMIN.DEVICES.SELECT_DATE' | translate }}:</label>

  <lin-datepicker-field-custom
    formControlName="selected"
    [isRange]="true"
    [isPlaceholderShown]="true"
    [isWithTimePicker]="true"
    [showEachDayCheckbox]="showEachDayCheckbox"
    (datePickerRangeChange)="onDateRangeChange($event)"
  ></lin-datepicker-field-custom>
  <lin-form-submit-button [isLoading]="isLoading" [isDisabled]="isDisabled"> {{ 'BUTTONS.SEARCH' | translate }} </lin-form-submit-button>
</form>
